import DefaultCompanyLogo from './component'
export { DefaultCompanyLogo }
export default DefaultCompanyLogo